import { styled } from 'css-literal-loader/styled';
import React from 'react';
import Dropdown from 'react-overlays/Dropdown';

const LinkButton = styled('button', null, "LinkButton", require("./DropdownToggle-LinkButton.module.scss"), "link-button", "linkButton");

export default function DropdownToggle(props) {
  return (
    <Dropdown.Toggle>
      {({ toggle, props: toggleProps }) => (
        <LinkButton {...props} {...toggleProps} onClick={toggle} />
      )}
    </Dropdown.Toggle>
  );
}
